import { commonUtils } from '@/helpers/commonUtils'
import style from './ActivityDesc.module.less'
import { observer } from 'mobx-react'
import classNames from 'classnames'

interface ActivityDescProps {
  type: 'max_year' | 'max_year_subscription' | 'ultra_year' | 'ultra_year_subscription'
  styleCSS?: React.CSSProperties
  className?: string
}

export const ActivityDesc = observer((_props: ActivityDescProps) => {
  const { type, styleCSS, className } = _props

  let primaryImg = commonUtils.getStaticFile('video_month_desc.png')
  let goldenBg = false
  if (type === 'ultra_year' || type === 'ultra_year_subscription') {
    primaryImg = commonUtils.getStaticFile('video_year_desc.png')
    goldenBg = true
  }

  return (
    <div
      className={classNames(style.activityDesc, { [style.goldenBg]: goldenBg }, className)}
      style={styleCSS}
    >
      <img src={primaryImg} className={classNames(style.icon)} loading='eager' />
    </div>
  )
})

interface ActivityBannerProps {
  type: 'max_year' | 'max_year_subscription' | 'ultra_year' | 'ultra_year_subscription'
  styleCSS?: React.CSSProperties
}

export const ActivityBanner = observer((_props: ActivityBannerProps) => {
  const { type, styleCSS } = _props

  const value = type === 'max_year' || type === 'max_year_subscription' ? '50' : '100'
  const timeType = type === 'max_year' || type === 'max_year_subscription' ? '月' : '季'

  let imgSrc = commonUtils.getStaticFile('video_month.png')
  if (type === 'ultra_year' || type === 'ultra_year_subscription') {
    imgSrc = commonUtils.getStaticFile('video_quarter.png')
  }

  return (
    <div className={style.activityBanner} style={styleCSS}>
      <img src={imgSrc} className={classNames(style.icon)} />
    </div>
  )
})
